export function getRCSOfCoordinate([x, y]) {
  return [x, y, (x - x % 3) + (y - y % 3) / 3];
}

export function areCoordinatePeers(pos1, pos2) {
  if (!pos1 || !pos2) {
    return false;
  }
  const [r1, c1, s1] = getRCSOfCoordinate(pos1);
  const [r2, c2, s2] = getRCSOfCoordinate(pos2);
  return (r1 === r2) || (c1 === c2) || (s1 === s2);
}

export async function callBackendAPI(api, parameters) {
  if (parameters) {
    api += '?' + new URLSearchParams(parameters);
  }
  const response = await fetch('/' + api);
  const body = await response;
  if (response.status !== 200) {
    throw Error(body.message) 
  }
  return body.json();
}

export function formatSeconds(totalSeconds) {
  let minutes = Math.floor(totalSeconds / 60);
  let seconds = totalSeconds - (minutes * 60);

  let result = (minutes < 10 ? "0" + minutes : minutes)
             + ":" + (seconds  < 10 ? "0" + seconds : seconds);
  return result;
}